import { useFormContext } from 'react-hook-form';

import { FloorFormData } from './types';

export const useFloorFormContext = () => {
  return useFormContext<FloorFormData>();
};
